export default __webpack_public_path__ + "static/news20-5ee0d0a2d089cc096855fa396fdab7cd.png";